angular.module('trainerWebApp.resources').factory('customCertificateResource',
  ['$resource', 'errorHandler', function ($resource, errorHandler) {
    var CustomCertificateResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/certificate/:courseId/custom/:type');

    CustomCertificateResource.prototype.getCustomCertificateInfo = function getCustomCertificateInfo(courseId, resultCb, errorCb) {
      return CustomCertificateResource.get({ courseId: courseId }, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    CustomCertificateResource.prototype.saveCustomCertificate = function saveCustomCertificate(data, resultCb, errorCb) {
      // Temporarily skip this until we fix the gaviota-api: handlers/certificate/updateCustomCertificate.js
      resultCb();

      return CustomCertificateResource.save({ courseId: data.courseId }, _.omit(data, 'courseId'), resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    CustomCertificateResource.prototype.saveBackgroundImage = function storeBackgroundImage(data, resultCb, errorCb) {
      return $resource(mfConfig.cModuleSeriesBaseUrlSegment + '/course/:courseId/certificate').save({ courseId: data.courseId }, _.omit(data, 'courseId'), resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new CustomCertificateResource();
  }]
);
